import React, { useState, useEffect, createRef } from "react";
import { Container, Row, Col, Stack, Badge, Button, Form, ListGroup, ToggleButton } from "react-bootstrap";
import { RequestService } from "../../../HttpService/RequestService";
import Placeholder from 'react-bootstrap/Placeholder';
import { ImKey } from "react-icons/im";
import Swal from 'sweetalert2'
import dateFormat from "dateformat";
import { BiBlock } from "react-icons/bi";
import { MdModeEdit } from "react-icons/md";
import { MdDelete, MdVisibility } from "react-icons/md";
import { HiLocationMarker } from "react-icons/hi";
import { TODIS_DROPDOWN } from "../../../components/Forms";
import { MODAL_USER } from "../../../components/Modals/ModalForm/ModalUser";
import { TODIS_BTN_PRIMARY, TODIS_BTN_SECUNDARY, TODIS_DATEPICKER } from "../../../components/Buttons";
import { BsGeoAlt, BsGrid, BsSortDownAlt, BsArrowClockwise, BsCloudSlashFill, BsSortDown, BsCalendarMinusFill, BsPlusLg, BsX, BsCheck, BsUnlock } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { AuxiliaryService } from "../../../HttpService/AuxiliaryService";
import 'sweetalert2/src/sweetalert2.scss'
import style from "./Users.module.scss";
import styleAdmin from "../Admin.module.scss";
import "../../DataCollection/style.css";
import { OrganizationsService } from "../../../HttpService/OrganizationService";
import Roles from "../Roles/Roles";

const Users = () => {

    const formUser = createRef();
    const navigate = useNavigate();

    const [modalUserForm, setModalUserForm] = useState(false)
    const [titleFormUser, setTitleFormUser] = useState("")
    const [order, setOrder] = useState(true)
    const [requests, setRequests] = useState([])
    const [responseR, setResponseR] = useState(false)
    const [roles, setRoles] = useState([])
    const [response, setResponse] = useState(false)
    const [usersNotFound, setUsersNotFound] = useState(false)
    const [regionals, setRegionals] = useState([])
    const [filterR, setFilterR] = useState({"Roles": [], "Regional Partner": [], "Date": null})
    const [filter, setFilter] = useState({})

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const getDataSelect = async() => {
        try {
            const auxiliaries = await new AuxiliaryService("auxData/regionalpartner").getAuxiliaries();
    
            auxiliaries.map(item => {
                if(item.txtNameTable == "regionalpartner")
                    setRegionals(item.auxtableDetailsDTOList)
            })
        } catch (error) {
            console.log("error listing selects", error);
        }
    }

    const getRoles = async() => {
        try {

            return await new OrganizationsService("role/roles/summary").getDataOrganizations();

        } catch (error) {
            console.log("error listing roles", error);
        }
    }

    const getRequests = async(filter) => {
        try {

            return await new RequestService("user/users").getRequests(filter);

        } catch (error) {
            console.log("error listing requests", error);
        }
    }

    const orderRequest = (order) => {
        setOrder(!order)
        setRequests(prevState => 
            {
                let newState = [...prevState];
                
                return  newState.sort(function (x, y) {
                    if(order)
                        return y.id - x.id;
                    else
                        return x.id - y.id;
                });
            }
        );
    }
    
    const deleteUser = async (id) => {
        try {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                //showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async(result) => {
                if (result.isConfirmed) {
                    let res = await new OrganizationsService("user/users/" + id).deleteUser();
                    
                    if(res.status == 200){
                        setRequests((prevState) => {
                            let newState = [...prevState]
                            newState = newState.filter(item => item.id != id)
                            return newState;
                        })
                        Swal.fire(
                        'Deleted!',
                        'The User has been deleted.',
                        'success'
                        )
                    }else{
                        console.log("error in delete User", res);
                    }
                }
            })
        } catch (error) {
            console.log("error in delete User", error);
        }
    }

    const blockUser = async (id, active) => {
        try {
             const res = await new OrganizationsService("user/block/" + id).blockUser();
            if (res.status == 201) {
                refreshRequest()
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Successfully blocked User',
                    showConfirmButton: false,
                    timer: 1500
                    })
            } else {
                console.log("error in block User", res);
            }
        } catch (error) {
            console.log("error in block User", error);
        }
    }

    const unblockUser = async (id) => {
        try {
            const res = await new OrganizationsService("user/unblock/" + id).blockUser();
            if (res.status == 201) {
                refreshRequest()
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Successfully unblocked User',
                    showConfirmButton: false,
                    timer: 1500
                    })
            } else {
                console.log("error in unblock User", res);
            }
        } catch (error) {
            console.log("error in unblock User", error);
        }
    }

    const refreshRequest = async () => {
        setOrder(true)
        setResponse(false);
        let res = await getRequests(null);
            if (res) {
                setRequests(prevState => 
                    {                        
                        return  res.sort(function (x, y) {
                            return x.id - y.id;
                        });
                    });
                setResponse(true);
            } else {
                setUsersNotFound(true);
            }
    }

    const handleSelectR = (value, e, name, id) => {
        if(!filterR[name].some(item => item.name == e.target.text)){
            setFilterR(prevState => {
                const newValue = {...prevState};
                newValue[name] = [...newValue[name], {id: value, name: e.target.text}]
                return newValue
            })
            setFilter(prevState => {
                const newValue = {...prevState};
                if(newValue[id] == undefined){
                    newValue[id] = [value]
                }else{
                    newValue[id].push(value)
                }
                return newValue
            })
        }else{
            Toast.fire({
                icon: 'warning',
                title: "Filter by " + name + " <b>" + e.target.text + "</b> is already applied"
              })
        }
    }
    
    const handleDate = (value, name) => {
        setFilterR(prevState => {
            const newValue = {...prevState};
            newValue[name] = value;
            //console.log("filterR:", newValue); // Console log de filter
            return newValue
        })
        const dateRange = value.split(' ~ ')
        setFilter(prevState => {
            const newValue = {...prevState};
            newValue["fromDate"] = dateFormat(dateRange[0], "dd/mm/yyyy");
            newValue["toDate"] = dateFormat(dateRange[1], "dd/mm/yyyy");
            return newValue;
        })


    }

    // const removeAllFilterR = () => {
    //     setFilterR({ "Roles": [], "Regional Partner": [], "Date": null })
    //     setFilter({})
    // }

    const removeAllFilterR = () => {
        setFilterR({ "Roles": [], "Regional Partner": [], "Date": null })
        setFilter({})
    }

    const removeFilterR = (name, id, value) => {
        setFilterR(prevState => {
            const newValue = {...prevState};
            newValue[name] = newValue[name].filter(item => item.id != value)
            //console.log("filter Request", newValue)
            return newValue
        })
        setFilter(prevState => {
            const newValue = {...prevState};
            newValue[id] = newValue[id].filter(item => item != value)
            if(newValue[id].length == 0)
                delete newValue[id]
            return newValue
        })
    }

    const removeFilterDate = (name) => {
        setFilterR(prevState => {
            const newValue = {...prevState};
            newValue[name] = null
            return newValue
        })

        setFilter(prevState => {
            const newValue = {...prevState};
            delete newValue["fromDate"]
            delete newValue["toDate"]
            return newValue
        })
    }

    const detailUser = (id, typeAction) => {
        setModalUserForm(true)
        formUser.current.detailUser(id, typeAction);
    }

    const avatarLabel = (name) => {
        let fullname = name.replace(".", " ");
        return fullname.split(' ').map(i => i.charAt(0)).toString().toUpperCase().split(',')
    }

    useEffect(() => {
        (async () => {
            // await getDataSelect();
            setResponse(false);
            let res = await getRequests(filter);
            let resR = await getRoles();
            if (res) {
                setRequests(prevState => 
                    {                        
                        return  res.sort(function (x, y) {
                            return x.id - y.id;
                        });
                    });
                setResponse(true);
            } else {
                setUsersNotFound(true);
            }
            if(resR){
                setRoles(prevState => 
                    {                        
                        return  resR.sort(function (x, y) {
                            return x.id - y.id;
                        });
                    });
                setResponseR(true);
            }
        })();
    }, [filter]);

    useEffect(() => {
        (async () => {
            await getDataSelect();
        })();
    }, []);

    return (
        <>
        <Col sm={8} >
            <Container fluid className="todis-form-wrapper p-4">
                <Row className="pb-3">
                    <Col lg={3} className="ps-4">
                        <Stack gap={0}>
                            <h4 className="todis-header"><BsCalendarMinusFill className="me-3" />System Users</h4>
                        </Stack>
                    </Col>
                    <Col lg={9}>
                        <Row className="float-end">
                            <Col lg={2} style={{ width: 'auto' }}>
                                <TODIS_DROPDOWN title="Regional Partner" handleSelect={(e, evt) => handleSelectR(e, evt, "Regional Partner", "regionalPartner")} response={response} items={regionals} icon={BsGeoAlt}/> 
                            </Col>
                            <Col lg={2} style={{ width: 'auto' }}>
                                <TODIS_DROPDOWN title="Role" handleSelect={(e, evt) => handleSelectR(e, evt, "Roles", "roles")} response={responseR} items={roles} icon={BsGrid}/>
                            </Col>
                            {/* <Col lg={1} style={{ width: 'auto' }}>
                                <TODIS_DATEPICKER handleDate={(data) => handleDate(data, "Date")}/>
                            </Col> */}
                             <Col lg={1} style={{ width: 'auto' }}>
                                <TODIS_DATEPICKER handleDate={(data) => handleDate(data, "Date")} placeholder="Date" text="Filter"/>
                            </Col>
                            <Col lg={1} style={{ width: 'auto' }}>
                                <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={order ? BsSortDownAlt : BsSortDown} onclick={() => orderRequest(order)}/>
                            </Col>
                            <Col lg={1} style={{ width: 'auto' }}>
                                <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => refreshRequest()}/>
                            </Col>
                            <Col>
                                <Button variant="outline-primary" onClick={() => {setTitleFormUser("Create"); setModalUserForm(true)}} className={`${styleAdmin.buttonAdmin} ${"todis-reset-btn float-end"}`} style={{margin: 0, padding: "0.7rem 1.5rem"}}><BsPlusLg className="me-3" size="16"/> CREATE NEW USER </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={12} className="ps-4 pt-4">
                        <Row className="float-start">
                            <Col lg={2} style={{ width: 'auto' }}>
                                <h6>
                                    Regional Partner: 
                                    {
                                        filterR["Regional Partner"].length != 0 ?
                                            filterR["Regional Partner"].map((item, index) => {
                                                return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterR("Regional Partner", "regionalPartner", item.id)}><BsX fontSize={16} color="#3e84b8"/></span> {item.name}</Badge>
                                            })
                                        : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8"/> All Regional Partner</Badge>
                                    }
                                </h6>
                            </Col>
                            <Col lg={2} style={{ width: 'auto' }}>
                                <h6>
                                    Roles: 
                                    {
                                        filterR["Roles"].length != 0 ?
                                            filterR["Roles"].map((item, index) => {
                                                return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterR("Roles", "roles", item.id)}><BsX fontSize={16} color="#3e84b8"/></span> {item.name}</Badge>
                                            })
                                        : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8"/> All Roles</Badge>
                                    }
                                </h6>
                            </Col>
                            <Col lg={2} style={{ width: 'auto' }}>
                                <h6>
                                    Date: 
                                    {
                                        filterR["Date"] != null ?
                                        <Badge className={style.bgFilter}><span className={style.cursorPointer} onClick={() => removeFilterDate("Date")}><BsX fontSize={16} color="#3e84b8"/></span> {filterR["Date"]}</Badge>
                                        : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8"/> All Date</Badge>
                                    }
                                </h6>
                            </Col>
                            {(filterR["Regional Partner"].length != 0 || filterR["Roles"].length != 0 || filterR["Date"]) &&
                                <Col lg={3} style={{ width: 'auto' }}>
                                    <h6 style={{ fontSize: "0.9rem", cursor: "pointer" }}><span onClick={() => removeAllFilterR()}><MdDelete size={18} color="red" className="me-1" />Remove Filter</span></h6>
                                </Col>
                            }
                        </Row>
                    </Col>
                </Row>
                <Row className="todis-form-action-panel pb-3" style={{overflow: "auto", maxHeight: "660px"}}>
                    {
                        !usersNotFound && response ?
                            (requests.map((request, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}>
                            <Container className="ms-2">
                                <Row>
                                    <Col lg={1} className="p-0 w-auto"> 
                                            <Row className="px-3">
                                            <div className={request.active ? style.avatarUser : style.avatarUserInactive}>{avatarLabel(request.userName)}</div>
                                            </Row> 
                                    </Col>
                                    <Col lg={8}>
                                        <h4 className="fw-bold">{request.name}</h4>
                                        <Row>
                                            <Col lg={3} className="w-auto">
                                                <span>{request.userName}</span>
                                            </Col>
                                            <Col lg={3} className="w-auto">
                                                <span>Create Date: {dateFormat(request.createdDate, "dd-mm-yyyy")}</span>
                                            </Col>
                                            <Col lg={6} className="w-auto">
                                            {request.roles.length > 0 ? request.roles.map((role) => (
                                                         <span><ImKey size="18" className="mx-2" color="#004494"/> {role.name}</span>
                                                    )) : null}
                                                {/* <span><ImKey size="18" className="me-1" color="#004494"/> {"Regional Partner"}</span> */}
                                            </Col>
                                            {/* <Col lg={3} className="w-auto">
                                                 <span><HiLocationMarker size="18" className="me-1" color="#004494"/> {request.regionalPartners[0]}</span> 
                                            </Col> */}
                                        </Row>
                                    </Col>
                                    <Col lg={3} className="p-0" style={{alignSelf: "center"}}>
                                        <Row>
                                            <Col lg={3}>
                                                <TODIS_BTN_SECUNDARY variant="primary" icon={MdVisibility} sizeIcon="20" style={{fontSize: "12px", padding: "0.7rem 1rem"}} onclick={() => {setTitleFormUser("Detail"); detailUser(request.id, "view")}}/>
                                            </Col>
                                            <Col lg={3}>
                                                <TODIS_BTN_SECUNDARY variant="primary" icon={MdModeEdit} sizeIcon="20" style={{fontSize: "12px", padding: "0.7rem 1rem"}} onclick={() => {setTitleFormUser("Update");detailUser(request.id, "update")}}/>
                                            </Col>
                                            <Col lg={3}>
                                            {request.active ? (
                                                <TODIS_BTN_SECUNDARY
                                                variant="primary"
                                                icon={ request.active? BiBlock:BsUnlock}
                                                sizeIcon="20"
                                                style={{ fontSize: "12px", padding: "0.7rem 1rem" }}
                                                onclick={() => blockUser(request.id)}
                                                />
                                            ) : (
                                                <TODIS_BTN_SECUNDARY
                                                variant="primary"
                                                icon={BsUnlock}
                                                sizeIcon="20"
                                                style={{ fontSize: "12px", padding: "0.7rem 1rem" }}
                                                onclick={() => unblockUser(request.id)}
                                                />
                                            )}
                                            </Col>
                                            <Col lg={3}>
                                                <TODIS_BTN_PRIMARY variant="primary" icon={MdDelete} sizeIcon="20" style={{fontSize: "12px", padding: "0.7rem 1rem"}} onclick={() => deleteUser(request.id)}/>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>))) : usersNotFound ?
                                <div className="h-100 d-flex justify-content-center align-items-center"> <div style={{ textAlign: "center" }}>
                                    <BsCloudSlashFill fontSize={100} color="#000000" />
                                    <h3 className="">Users Not found </h3>
                                </div></div> :

                                // loading requests 
                                ([...Array(7)].map((request, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}><Container>
                                    <Row>
                                        <Col lg={1}>
                                            <Placeholder as="h1" animation="glow"><Placeholder xs={8} size="md" /></Placeholder>
                                        </Col>
                                        <Col lg={8}>
                                            <Placeholder as="h4" animation="glow"><Placeholder xs={8} size="md" /></Placeholder>
                                            <Row>
                                                <Col lg={1} >
                                                    <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                </Col>
                                                <Col lg={2} >
                                                    <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                </Col>
                                                <Col lg={3} >
                                                    <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg={3} className="p-0">
                                            <Row>
                                                <Col lg={3}>
                                                    <Placeholder.Button variant="light" xs={12} size="md" />
                                                </Col>
                                                <Col lg={3}>
                                                    <Placeholder.Button variant="light" xs={12} size="md" />
                                                </Col>
                                                <Col lg={3}>
                                                    <Placeholder.Button variant="light" xs={12} size="md" />
                                                </Col>
                                                <Col lg={3}>
                                                    <Placeholder.Button variant="light" xs={12} size="md" />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Container></Col>)))
                    }
                </Row>
            </Container>
        </Col>
        <Col sm={4}>
            <Roles />
            <MODAL_USER ref={formUser} show={modalUserForm} onHide={() => setModalUserForm(false)} refreshRequest={refreshRequest} titleFormUser={titleFormUser} /> 
        </Col>
        </>
    );
}

export default Users;